/* eslint-disable import/prefer-default-export */
export const blurInputOnEnter: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
  if (e.key === 'Enter') {
    if (document.activeElement) {
      const activeElement = document.activeElement as HTMLInputElement
      activeElement.blur()
    }
  }
}
